export default "__VITE_ASSET__D9J8J4uH__"